import MarketingLayout from "@/components/layouts/MarketingLayout";
import SEOHead from "@/components/SEOHead";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Features from "@/components/Features";
import Stats from "@/components/Stats";
import CTA from "@/components/CTA";
import TestimonialCard from "@/components/marketing/TestimonialCard";
import AnimateOnScroll from "@/components/AnimateOnScroll";

import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Index = () => {
  return (
    <MarketingLayout>
      <SEOHead 
        title="Superdynamic - AI Agent That Optimizes Your Website 24/7"
        description="Your AI agent analyzes, personalizes, tests, and optimizes your website automatically. Boost conversions without code. Works with Shopify, WordPress, Webflow."
        canonicalUrl="https://superdynamic.io"
      />

      <Hero />

      <HowItWorks />

      <Features />

      {/* Testimonials */}
      <section className="py-24 bg-muted/30">
        <div className="container mx-auto px-4">
          <AnimateOnScroll>
            <header className="text-center max-w-2xl mx-auto mb-16">
              <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-tight">
                Results that speak for themselves
              </h2>
              <p className="text-lg text-muted-foreground">
                See what happens when an AI agent optimizes your site around the clock.
              </p>
            </header>
          </AnimateOnScroll>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <AnimateOnScroll delay={0}>
              <TestimonialCard
                quote="In 3 weeks the agent increased conversion by 34%. We didn't touch a thing."
                author="María García"
                role="Head of Growth"
                company="FashionStore"
                metric={{ value: "+34%", label: "Conversion" }}
              />
            </AnimateOnScroll>
            <AnimateOnScroll delay={150}>
              <TestimonialCard
                quote="We went from 200 to 600 monthly leads with the same traffic. The agent found segments we never considered."
                author="Carlos Ruiz"
                role="CMO"
                company="SaaS Academy"
                metric={{ value: "3x", label: "More leads" }}
              />
            </AnimateOnScroll>
            <AnimateOnScroll delay={300}>
              <TestimonialCard
                quote="Bounce rate dropped by 28%. The agent personalized content for every visitor source automatically."
                author="Ana López"
                role="Product Manager"
                company="TechSolutions"
                metric={{ value: "-28%", label: "Bounce rate" }}
              />
            </AnimateOnScroll>
          </div>

          <AnimateOnScroll delay={400}>
            <div className="text-center mt-12">
              <Button variant="outline" className="rounded-full" asChild>
                <Link to="/resources/case-studies">
                  View all case studies
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>
            </div>
          </AnimateOnScroll>
        </div>
      </section>

      <Stats />
      
      <CTA />
    </MarketingLayout>
  );
};

export default Index;
